import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);
const JournalDetailServices={
    async saveJournalDetail(_payload){
        const url="api/Save_Journal"
        return await ApiService.post(url, _payload);
    },
    async getActiveAccountPeriod(){
        const getActiveAccountPeriod = {
            url: "api/JournalActiveAccountingPeriod",
            top: "1",
          };
        return await ApiService.oDataGet(getActiveAccountPeriod);
    },
    async getJournal(code){
        const journal = {
            url: "api/Journal",
            filter: `JournalCode eq ${code}`,
            top: "1",
        };
        return ApiService.oDataGet(journal);
    },
    async getJournalDetail(code){
        const journalDetail = {
            url: "api/JournalDetail",
            filter: `JournalCode eq ${code}`,
            top: "1000",
        };
        return ApiService.oDataGet(journalDetail);
    }
}
export {JournalDetailServices}